import React from "react";

import PhoneFrameTwo from "@pages/Applications/C&C/C&CSetup/Common/PhoneFrameTwo";
import { useTemplateData } from "@constants/template";
import { NoPicture } from "@components/Common/SvgIcons";

export function StartupScreenPreview(): JSX.Element {
    const { getImageUrl, iuud } = useTemplateData();

    const imageBannier = getImageUrl(
        ["Application", "ImagePublicite", "Logo"],
        iuud
    );

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "80vh",
                borderLeft: "1px #c6c7c9 solid",
            }}
        >
            <div
                style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "90%",
                }}
            >
                <PhoneFrameTwo>
                    {" "}
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {imageBannier ? (
                            <img
                                src={imageBannier}
                                alt=""
                                width={150}
                                height={150}
                            />
                        ) : (
                            <NoPicture
                                height="150px"
                                width="150px"
                                className="flag__clz"
                            />
                        )}
                    </div>{" "}
                </PhoneFrameTwo>
            </div>
        </div>
    );
}
